export default __webpack_public_path__ + "static/media/reverseMasterball.61c66b26.svg";